import { lazy } from 'solid-js'
import { messages } from '../../pages/not-found-page/not-found-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/not-found-page/not-found-page.jsx')),
    // Catch all route: https://docs.solidjs.com/solid-router/concepts/catch-all
    // Will return unmatched route as a param in the controller
    path: '*unmatchedRoute',
    titleMessage: messages.titleMessage,
}
